import React from "react";
import { Route, Routes } from "react-router-dom";

import HabitsListPage from "~/modules/Habits/HabitsListPage";

const HabitsRouter = (): React.ReactElement => {
  return (
    <Routes>
      <Route index element={<HabitsListPage />} />
    </Routes>
  );
};

export default HabitsRouter;
